import { IBreadcrumbItem } from "@fluentui/react/lib/Breadcrumb";
import { Location } from "history";

/**
 * Parameters required to build ZedXMainApp breadcrumb
 */
export interface ZedXMainAppBreadcrumbParams {
    customerTitle: string;
    location: Location;
    history: any;
}

/**
 * Builds breadcrumb items for ZedXMainApp
 */
export const buildZedXMainAppBreadcrumb = (
    params: ZedXMainAppBreadcrumbParams
): IBreadcrumbItem[] => {
    const { customerTitle, location, history } = params;
    const items: IBreadcrumbItem[] = [];

    // Always add root item
    items.push({
        text: 'ZedX Apps',
        key: "root",
        onClick: () => history.push("/"),
    });

    // Determine current path
    let path = location.pathname || "";
    if ((!path || path === "/") && location.hash) {
        path = location.hash.replace(/^#/, "").split("?")[0].split("#")[0];
    }

    // Only add route-specific items if needed
    if (path === "/account/change-password") {
        items.push({ text: "Change Password", key: "change-password", isCurrentItem: true });
    }

    // For the main page ("/"), do nothing else

    return items;
};
